import useToaster from './useToaster';

// export hooks
export { useToaster };
export default useToaster;
